import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';
import { UnitSizeService } from 'app/server/server.module';

@Component({
  selector: 'app-unitsize-object-lookup',
  templateUrl: './unitsize-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class UnitSizeObjectLookupComponent extends ObjectLookupComponent {
  constructor(private unitSizeService: UnitSizeService) {
    super();
  }

  protected loadObjectByIdFromService(id: number) {    
    this.unitSizeService.getUnitSize(id);
    this.unitSizeService.UnitSize$.pipe(catchError(() => of(null))).subscribe((result: any) => {
      this.isLoadingObject = false;
      if (result) {
        this.selectedObject = result;
        this.searchTerm = this.getObjectName(result);
        this.isSearching = false;
      } else {
        this.selectedObject = null;
        this.searchResults = [];
        this.searchTerm = '';
        this.isSearching = true;
      }
    });
  }

  public getObjectType(): string {
    return 'UnitSize';
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    if (!searchText) return of([]);
    return this.unitSizeService.unitSizes$.pipe(
      map(list => (list || []).filter(c => this.getObjectName(c).toLowerCase().includes(searchText.toLowerCase()))),
      catchError(() => of([]))
    );
  }

  public getObjectName(item: any): string {
    return item?.Name || item?.SingleName || item?.PluralName || '';
  }

  public getObjectId(item: any): number | null {
    return item?.UnitSizeID ?? item?.ID ?? null;
  }
}
